export default __webpack_public_path__ + "static/media/Galaxy flare_primary.da6845b8.jpg";